// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__srwnX","panel":"PrivacyPolicy_panel__Ooi7a"};